import { Color, Log, MakeColorGradient, Point, Rect, Scale, Size } from "../.././MyHelpers";
import { PlayWindow } from "../../api";
import { ZIndex } from "../../ZIndex";

export class WinLines
{
	private slotWindow: Rect = null;
	private slotWindowSymbolSize: PlayWindow = null;
	private lines: number[][] = [];

	private lineElements: SVGPolylineElement[] = [];

	private view: SVGSVGElement = null;

	private logGroup = "WinLines";

	private colors: Color[] = [];

	constructor(slotWindow: Rect, slotWindowSymbolSize: PlayWindow, lines: number[][]) {

		this.slotWindow = slotWindow;
		this.slotWindowSymbolSize = slotWindowSymbolSize;
		this.lines = lines;

		this.CreateLines();
	}

	private CreateLines(){
		let svgNS = "http://www.w3.org/2000/svg";
		this.view = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

		this.view.classList.add("paylines");
		this.view.style.position = "absolute";
		this.view.style.width = this.slotWindow.width+ "px";
		this.view.style.height = this.slotWindow.height+ "px";
		this.view.style.left = this.slotWindow.x + "px";
		this.view.style.top = this.slotWindow.y + "px";
		this.view.style.pointerEvents = "none";
		this.view.style.zIndex=ZIndex.WinLines.toString();
		let symbolSize: Size = new Size(
			this.slotWindow.width / this.slotWindowSymbolSize.Width,
			this.slotWindow.height / this.slotWindowSymbolSize.Height,
		);

		// find center of each symbol in slot window
        let symbolsCenters: Point[][] = [];

        for (let i = 0; i < this.slotWindowSymbolSize.Width; i++) {
            symbolsCenters.push([]);

            for (let j = 0; j <  this.slotWindowSymbolSize.Height + 1; j++) {

            	let center: Point = new Point(
            		(i + 0.5) * symbolSize.Width,
            		(j + 0.5) * symbolSize.Height
            	);

                symbolsCenters[i].push(center);
            }
        }

        // generate svg lines from center to center
        // each line has straing on beginning and end

        this.colors = MakeColorGradient(2.4, 2.4, 2.4, 0, 2, 4, 128, 127, 50, 1);

        for (let lineIndex = 0; lineIndex < this.lines.length; lineIndex++) {
            let path: string = "";

            let color = this.colors[lineIndex % this.colors.length];
            //let color = "rgb(0, 0, 0)";



            for (let j = 0; j < this.lines[lineIndex].length; j++) {

                let reelIndex = j;
                let symIndex = this.lines[lineIndex][j];

                // first straight part
                if (j == 0) {
                    path += 0 + "," + symbolsCenters[reelIndex][symIndex].y;
                }

                path += " " + symbolsCenters[reelIndex][symIndex].x + "," + symbolsCenters[reelIndex][symIndex].y;

                // last straight part
                if (j == this.lines[lineIndex].length - 1) {
                    path += " " + this.slotWindow.width + "," + symbolsCenters[reelIndex][symIndex].y;;
                }
            }

            let paylineObject: SVGPolylineElement = <SVGPolylineElement>document.createElementNS(svgNS, "polyline");

            paylineObject.setAttributeNS(null, "points", path);
            paylineObject.setAttributeNS(null, "style", `fill: none; stroke: ${color.toRgba()}; stroke-width: ${Scale.XY(10)};`);

            // hide by default
            paylineObject.style.visibility = "hidden";

            this.lineElements.push(paylineObject);
            this.view.appendChild(paylineObject);
        }
	}

	public Show(lineIndex: number): void {
		if (lineIndex >= 0 && lineIndex < this.lineElements.length)
		{
			this.lineElements[lineIndex].style.visibility = "visible";
		}
		else {
			Log.Error(this.logGroup, "Tried to show line " + lineIndex + ", that does not exist. Lines: " + this.lineElements.length);
		}
	}

	public Hide(lineIndex: number): void {
		if (lineIndex >= 0 && lineIndex < this.lineElements.length) {
			this.lineElements[lineIndex].style.visibility = "hidden";
		}
		else {
			Log.Error(this.logGroup, "Tried to hide line " + lineIndex + ", that does not exist. Lines: " + this.lineElements.length);
		}
	}

	public GetColor(lineIndex: number): Color {
		return this.colors[lineIndex % this.colors.length];
	}

	public View(): SVGSVGElement {
		return this.view;
	}
}